import { ROLE_PERMISSIONS } from 'config/permissions';
import { useEnumApi } from 'contexts/EnumApiContext';

const usePermission = () => {
  const { role, isUserLoading } = useEnumApi();

  const permissions = (!isUserLoading && role && role !== 'NONE')
        ? ROLE_PERMISSIONS[role] || []
        : [];

  const hasPermission = permission => {
    return permissions.includes(permission);
  };

  const isPermissionReady = !!(!isUserLoading && role && role !== 'NONE');
// console.log(isPermissionReady)
  const isMenuVisible = menu => {
    const permissionOk =
        !menu.permission || hasPermission(menu.permission);

    const featureOk =
        menu.feature === undefined || menu.feature;

    return permissionOk && featureOk;
  };

  return {
    permissions,
    hasPermission,
    isPermissionReady,
    isMenuVisible
  };
};

export default usePermission;